import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../authProvider";

export default function RedirectIfNotAuthenticated({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user } = useAuthStore();

  if (!user) {
    return <Navigate to="/login" />;
  }

  return children;
}
